// Layout writes during ResizeObserver delivery can trigger another resize in
// the same frame. Coalesce them into the next frame and cancel on cleanup.
export default function observeLayoutResize(elements, update) {
  let frame = null;
  let disposed = false;
  const schedule = () => {
    if (disposed || frame !== null) return;
    frame = window.requestAnimationFrame(() => {
      frame = null;
      if (!disposed) update();
    });
  };
  const observer = typeof ResizeObserver === "undefined"
    ? null : new ResizeObserver(schedule);
  elements.filter(Boolean).forEach((element) => observer?.observe(element));
  window.addEventListener("resize", schedule);
  return () => {
    disposed = true;
    observer?.disconnect();
    window.removeEventListener("resize", schedule);
    if (frame !== null) window.cancelAnimationFrame(frame);
  };
}
